// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"8a4d683f","615":"ee661489"}[chunkId] + ".chunk.js";
};